import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export * from './payout-request-all/payout-request-all.component';
export * from './payout-request-monthly/payout-request-monthly.component';
export * from './payout-request-ondemand/payout-request-ondemand.component';
export * from './payout-request-transaction-hold/payout-request-transaction-hold.component';
export * from './payout-request-transaction/payout-request-transaction.component';

import { Route } from '@angular/router';







export const Routing: Route[] = [
  {
    path: 'payout/payouts-requests/all',
    loadComponent: () => import('./payout-request-all/payout-request-all.component').then(m => m.PayoutRequestAllComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Payouts Requests All' },
  },
  {
    path: 'payout/payouts-requests/monthly',
    loadComponent: () => import('./payout-request-monthly/payout-request-monthly.component').then(m => m.PayoutRequestMonthlyComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Payouts Requests Monthly' },
  },
  {
    path: 'payout/payouts-requests/ondemand',
    loadComponent: () => import('./payout-request-ondemand/payout-request-ondemand.component').then(m => m.PayoutRequestOndemandComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Payouts Requests On-Demand' },
  },
  {
    path: 'payout/payouts-requests/transactions/:instructorId/hold',
    loadComponent: () => import('./payout-request-transaction-hold/payout-request-transaction-hold.component').then(m => m.PayoutRequestTransactionHoldComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Payouts Requests Transactions Hold' },
  },
  {
    path: 'payout/payouts-requests/:payoutRequestId',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'all'
      },
      {
        path: ':payoutStatus',
        loadComponent: () => import('./payout-request-transaction/payout-request-transaction.component').then(m => m.PayoutRequestTransactionComponent),
        data: { title: marker('E-Commerce'), breadcrumb: 'Payouts Requests Transactions' },
      },
    ]
  },
];
